import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';

import { LocalStorage } from './enums/storage.enum';
import { changePasswordRoute } from './router/changePassword.route';
import { layoutRoute } from './router/layout.route';
import { notFoundRoute } from './router/start/pageNotFound.route';
import { startRoute } from './router/start.route';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [changePasswordRoute, layoutRoute, startRoute, notFoundRoute],
  scrollBehavior: (_to, _from, savedPosition) => savedPosition || { x: 0, y: 0 }
} as RouterOptions);

router.beforeEach((to, from, next) => {
  if (to.matched.some((record: any) => record.meta.authorized) && !localStorage.getItem(LocalStorage.TOKEN)) {
    return store.dispatch('auth/unauthorize').then(() => next({ name: 'login' }));
  }

  next();
});

export default router;
